// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --odd: #ffffff;
  --odd-hover: rgb(246, 246, 246);
  --even: #e7e7e7;
  --even-hover: #cbcbcb;
  --desktop: #ffffff;
  --background: white;
}

a {
  text-decoration: none;
  color: black;
}

ul {
  list-style: none;
}

button {
  background-color: transparent;
  border: none;
  font-size: 2em;
  cursor: pointer;
}

img {
  height: 75px;
}

.Navbar {
  background-color: var(--background);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  box-shadow: 0 2px 15px 0 rgba(68, 67, 73, 0.2);
  z-index: 255;
}

.Navbar__left,
.Navbar__right {
  width: 100%;
  text-align: center;
}

.Navbar__links {
  height: 0;
  visibility: hidden;
  opacity: 0;
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 0;
  transition:
    visibility 0.5s ease,
    opacity 0.5s ease;
}

.Navbar__links a {
  position: relative;
  display: inline-block;
  text-decoration: none;
  color: black;
  padding: 0.75rem 1rem;
  z-index: 255;
}

.Navbar__links a::before {
  content: "";
  position: absolute;
  width: 0%;
  height: 2px;
  bottom: 0;
  left: 50%;
  background-color: #0c5298;
  transition:
    width 0.2s ease,
    left 0.2s ease;
}

.Navbar__links a:hover::before {
  width: 100%;
  left: 0;
}

.Navbar__links a:hover {
  color: #0c5298;
}

ul > a {
  padding: 1.4em 1em;
}

ul > a:nth-of-type(even) {
  background-color: var(--even);
}

ul > a:nth-of-type(even):hover {
  background-color: var(--even-hover);
  transition: 0.5s ease-in-out;
}

ul > a:nth-of-type(odd):hover {
  transition: 0.5s ease-in-out;
  background-color: var(--odd-hover);
}

ul > a:nth-of-type(odd) {
  background-color: var(--odd);
}

.register-menu.open .dropdown-content {
  display: block;
}
.resources-menu.open .dropdown-content {
  display: block;
}

.register-menu span {
  display: inline-block;
  padding: 12px 1em;
  color: black;
  position: relative;
}
.resources-menu span{
  display: inline-block;
  padding: 12px 1em;
  color: black;
  position: relative;
}

.register-menu span::before {
  content: "";
  position: absolute;
  width: 0%;
  height: 2px;
  bottom: 0;
  left: 50%;
  background-color: #0c5298;
  transition:
    width 0.2s ease,
    left 0.2s ease;
}
.resources-menu span::before{
  content: "";
  position: absolute;
  width: 0%;
  height: 2px;
  bottom: 0;
  left: 50%;
  background-color: #0c5298;
  transition:
    width 0.2s ease,
    left 0.2s ease;
}

.register-menu span:hover::before {
  width: 100%;
  left: 0;
}

.resources-menu span:hover::before {
  width: 100%;
  left: 0;
}

.register-menu span:hover {
  color: #0c5298;
}

.resources-menu span:hover{
  color: #0c5298;
}

.register-menu.open .dropdown-content {
  display: block;
}

.resources-menu.open .dropdown-content{
  display: block;
}

.dropdown-content {
  display: block;
  background-color: white;
  z-index: 256;
  width: 100%;
  border: none;
}

.dropdown-content p{
  margin: 8px
}

.dropdown-content li {
  padding: 0;
  background-color: white;
}

.dropdown-content li:hover {
  background-color: #f1f1f1;
}

.dropdown-content li a {
  color: black;
  text-decoration: none;
  width: 100%;
  font-size: 15px;
}

.dropdown-content li a:hover {
  color: #0c5298;
}

.menuToggler {
  display: inline-block;
  font-size: 2rem;
  cursor: pointer;
}

.showLinks {
  height: auto;
  opacity: 100;
  visibility: visible;
}

.spacer {
  height: 144px;
}

.navlogo img {
  width: 120px;
  height: 82.5px;
  margin-top: 15px;
}

.desktop-only {
  display: none;
}

.logoname {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logoname img{
  justify-content: center;
  width: 80px;
  height: 30px;
}

@media screen and (max-width: 1100px) {

  .Navbar {
    display: flex;
    flex-direction: row;
    padding: 30px 20px;
    height: auto;
  }

  .logoname{
    padding: 5px 5px;
    position:absolute;
    top: 12px;
    left: 80px;
  }
  .navlogo{
    position:absolute;
    top: 12px;
  }
  .navlogo img {
    width: 60px;
    height: auto;
    margin: 0;
  }

  .desktop-only {
    display: none;
  }

  .register-menu span {
    padding: 12px 15px; 
    font-size: 1rem; 
    width: 100%;
    background-color: var(--background);
  }
  .resources-menu span{
    padding: 12px 15px; 
    font-size: 1rem; 
    width: 100%;
    background-color: var(--background);
  }

  .menuToggler {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right:12px;
    top: 12px;
    z-index: 256;
  }

  .Navbar__links {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: left;
    visibility: visible;
    opacity: 1;
    transition: none; 
  }

  .Navbar__links a {
    padding: 12px 15px; 
    font-size: 1rem; 
    width: 100%;
    background-color: var(--background);
  }

  .dropdown-content {
    position: static;
    width: 100%;
    background-color: #e7e7e7;
  }

  .dropdown-content li a {
    padding: 12px 2rem;
    font-size: 1rem;
    display: block;
  }

  .showLinks {
    height: auto;
    opacity: 1;
    visibility: visible;
    margin-top: 25px;
  }
  ul > a:nth-of-type(even),
  ul > a:nth-of-type(even):hover,
  ul > a:nth-of-type(odd),
  ul > a:nth-of-type(odd):hover {
    background-color: var(--desktop);
  }

  .spacer {
    height: 65px;
  }

  .Navbar__links {
    height: 0;
    overflow: hidden;
    visibility: hidden;
    opacity: 0;
    transition: height 0.3s ease, opacity 0.3s ease;
  }

  .Navbar__links.showLinks {
    height: auto; 
    visibility: visible;
    opacity: 1;
  }
}

@media screen and (min-width: 1100px) {
  .Navbar__links {
    height: auto;
    visibility: visible;
    opacity: 100;
    display: flex;
    flex-direction: row;
    text-align: center;
    justify-content: center;
    gap: 2em;
    align-items: center;
    transition:
      visibility 0s,
      opacity 0.5s,
      height 0.3s;
  }

  .logoname {
    visibility: hidden;
    display: none;
  }

  .mobile-only {
    display: none;
  }

  .desktop-only {
    display: inline-block;
  }

  .menuToggler {
    display: none;
  }

  .showLinks {
    display: none;
  }

  ul > a:nth-of-type(even),
  ul > a:nth-of-type(even):hover,
  ul > a:nth-of-type(odd),
  ul > a:nth-of-type(odd):hover {
    background-color: var(--desktop);
  }

  a {
    padding: 0em;
  }

  a:hover {
    color: #0c5298;
  }

  .register-menu {
    position: relative;
  }
  .resources-menu{
    position: relative;
  }

  .register-menu .dropdown-content {
    display: none;
    position: absolute;
    top: 100%;
    left: -25px;
    background-color: white;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
    width: 150px;
  }

  .resources-menu .dropdown-content {
    display: none;
    position: absolute;
    top: 100%;
    left: -17px;
    background-color: white;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
    width: 150px;
  }

  .register-menu:hover .dropdown-content {
    display: block;
  }
  .resources-menu:hover .dropdown-content {
    display: block;
  }

  .register-menu.open .dropdown-content {
    display: none;
  }
  .resources-menu.open .dropdown-content {
    display: none;
  }

  .spacer {
    height: 150px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Navbar.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN;;qBAEmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;EACT,SAAS;EACT,yBAAyB;EACzB;;kBAEgB;AAClB;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;EACT,SAAS;EACT,yBAAyB;EACzB;;kBAEgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;EACT,SAAS;EACT,yBAAyB;EACzB;;kBAEgB;AAClB;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mCAAmC;EACrC;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mCAAmC;EACrC;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mCAAmC;EACrC;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,gBAAgB;EAClB;EACA;;;;IAIE,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,+CAA+C;EACjD;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB;;;iBAGa;EACf;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,2CAA2C;IAC3C,YAAY;EACd;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,2CAA2C;IAC3C,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[":root {\n  --odd: #ffffff;\n  --odd-hover: rgb(246, 246, 246);\n  --even: #e7e7e7;\n  --even-hover: #cbcbcb;\n  --desktop: #ffffff;\n  --background: white;\n}\n\na {\n  text-decoration: none;\n  color: black;\n}\n\nul {\n  list-style: none;\n}\n\nbutton {\n  background-color: transparent;\n  border: none;\n  font-size: 2em;\n  cursor: pointer;\n}\n\nimg {\n  height: 75px;\n}\n\n.Navbar {\n  background-color: var(--background);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: fixed;\n  box-shadow: 0 2px 15px 0 rgba(68, 67, 73, 0.2);\n  z-index: 255;\n}\n\n.Navbar__left,\n.Navbar__right {\n  width: 100%;\n  text-align: center;\n}\n\n.Navbar__links {\n  height: 0;\n  visibility: hidden;\n  opacity: 0;\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  gap: 0;\n  transition:\n    visibility 0.5s ease,\n    opacity 0.5s ease;\n}\n\n.Navbar__links a {\n  position: relative;\n  display: inline-block;\n  text-decoration: none;\n  color: black;\n  padding: 0.75rem 1rem;\n  z-index: 255;\n}\n\n.Navbar__links a::before {\n  content: \"\";\n  position: absolute;\n  width: 0%;\n  height: 2px;\n  bottom: 0;\n  left: 50%;\n  background-color: #0c5298;\n  transition:\n    width 0.2s ease,\n    left 0.2s ease;\n}\n\n.Navbar__links a:hover::before {\n  width: 100%;\n  left: 0;\n}\n\n.Navbar__links a:hover {\n  color: #0c5298;\n}\n\nul > a {\n  padding: 1.4em 1em;\n}\n\nul > a:nth-of-type(even) {\n  background-color: var(--even);\n}\n\nul > a:nth-of-type(even):hover {\n  background-color: var(--even-hover);\n  transition: 0.5s ease-in-out;\n}\n\nul > a:nth-of-type(odd):hover {\n  transition: 0.5s ease-in-out;\n  background-color: var(--odd-hover);\n}\n\nul > a:nth-of-type(odd) {\n  background-color: var(--odd);\n}\n\n.register-menu.open .dropdown-content {\n  display: block;\n}\n.resources-menu.open .dropdown-content {\n  display: block;\n}\n\n.register-menu span {\n  display: inline-block;\n  padding: 12px 1em;\n  color: black;\n  position: relative;\n}\n.resources-menu span{\n  display: inline-block;\n  padding: 12px 1em;\n  color: black;\n  position: relative;\n}\n\n.register-menu span::before {\n  content: \"\";\n  position: absolute;\n  width: 0%;\n  height: 2px;\n  bottom: 0;\n  left: 50%;\n  background-color: #0c5298;\n  transition:\n    width 0.2s ease,\n    left 0.2s ease;\n}\n.resources-menu span::before{\n  content: \"\";\n  position: absolute;\n  width: 0%;\n  height: 2px;\n  bottom: 0;\n  left: 50%;\n  background-color: #0c5298;\n  transition:\n    width 0.2s ease,\n    left 0.2s ease;\n}\n\n.register-menu span:hover::before {\n  width: 100%;\n  left: 0;\n}\n\n.resources-menu span:hover::before {\n  width: 100%;\n  left: 0;\n}\n\n.register-menu span:hover {\n  color: #0c5298;\n}\n\n.resources-menu span:hover{\n  color: #0c5298;\n}\n\n.register-menu.open .dropdown-content {\n  display: block;\n}\n\n.resources-menu.open .dropdown-content{\n  display: block;\n}\n\n.dropdown-content {\n  display: block;\n  background-color: white;\n  z-index: 256;\n  width: 100%;\n  border: none;\n}\n\n.dropdown-content p{\n  margin: 8px\n}\n\n.dropdown-content li {\n  padding: 0;\n  background-color: white;\n}\n\n.dropdown-content li:hover {\n  background-color: #f1f1f1;\n}\n\n.dropdown-content li a {\n  color: black;\n  text-decoration: none;\n  width: 100%;\n  font-size: 15px;\n}\n\n.dropdown-content li a:hover {\n  color: #0c5298;\n}\n\n.menuToggler {\n  display: inline-block;\n  font-size: 2rem;\n  cursor: pointer;\n}\n\n.showLinks {\n  height: auto;\n  opacity: 100;\n  visibility: visible;\n}\n\n.spacer {\n  height: 144px;\n}\n\n.navlogo img {\n  width: 120px;\n  height: 82.5px;\n  margin-top: 15px;\n}\n\n.desktop-only {\n  display: none;\n}\n\n.logoname {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.logoname img{\n  justify-content: center;\n  width: 80px;\n  height: 30px;\n}\n\n@media screen and (max-width: 1100px) {\n\n  .Navbar {\n    display: flex;\n    flex-direction: row;\n    padding: 30px 20px;\n    height: auto;\n  }\n\n  .logoname{\n    padding: 5px 5px;\n    position:absolute;\n    top: 12px;\n    left: 80px;\n  }\n  .navlogo{\n    position:absolute;\n    top: 12px;\n  }\n  .navlogo img {\n    width: 60px;\n    height: auto;\n    margin: 0;\n  }\n\n  .desktop-only {\n    display: none;\n  }\n\n  .register-menu span {\n    padding: 12px 15px; \n    font-size: 1rem; \n    width: 100%;\n    background-color: var(--background);\n  }\n  .resources-menu span{\n    padding: 12px 15px; \n    font-size: 1rem; \n    width: 100%;\n    background-color: var(--background);\n  }\n\n  .menuToggler {\n    display: flex;\n    justify-content: flex-end;\n    position: absolute;\n    right:12px;\n    top: 12px;\n    z-index: 256;\n  }\n\n  .Navbar__links {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n    visibility: visible;\n    opacity: 1;\n    transition: none; \n  }\n\n  .Navbar__links a {\n    padding: 12px 15px; \n    font-size: 1rem; \n    width: 100%;\n    background-color: var(--background);\n  }\n\n  .dropdown-content {\n    position: static;\n    width: 100%;\n    background-color: #e7e7e7;\n  }\n\n  .dropdown-content li a {\n    padding: 12px 2rem;\n    font-size: 1rem;\n    display: block;\n  }\n\n  .showLinks {\n    height: auto;\n    opacity: 1;\n    visibility: visible;\n    margin-top: 25px;\n  }\n  ul > a:nth-of-type(even),\n  ul > a:nth-of-type(even):hover,\n  ul > a:nth-of-type(odd),\n  ul > a:nth-of-type(odd):hover {\n    background-color: var(--desktop);\n  }\n\n  .spacer {\n    height: 65px;\n  }\n\n  .Navbar__links {\n    height: 0;\n    overflow: hidden;\n    visibility: hidden;\n    opacity: 0;\n    transition: height 0.3s ease, opacity 0.3s ease;\n  }\n\n  .Navbar__links.showLinks {\n    height: auto; \n    visibility: visible;\n    opacity: 1;\n  }\n}\n\n@media screen and (min-width: 1100px) {\n  .Navbar__links {\n    height: auto;\n    visibility: visible;\n    opacity: 100;\n    display: flex;\n    flex-direction: row;\n    text-align: center;\n    justify-content: center;\n    gap: 2em;\n    align-items: center;\n    transition:\n      visibility 0s,\n      opacity 0.5s,\n      height 0.3s;\n  }\n\n  .logoname {\n    visibility: hidden;\n    display: none;\n  }\n\n  .mobile-only {\n    display: none;\n  }\n\n  .desktop-only {\n    display: inline-block;\n  }\n\n  .menuToggler {\n    display: none;\n  }\n\n  .showLinks {\n    display: none;\n  }\n\n  ul > a:nth-of-type(even),\n  ul > a:nth-of-type(even):hover,\n  ul > a:nth-of-type(odd),\n  ul > a:nth-of-type(odd):hover {\n    background-color: var(--desktop);\n  }\n\n  a {\n    padding: 0em;\n  }\n\n  a:hover {\n    color: #0c5298;\n  }\n\n  .register-menu {\n    position: relative;\n  }\n  .resources-menu{\n    position: relative;\n  }\n\n  .register-menu .dropdown-content {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: -25px;\n    background-color: white;\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);\n    width: 150px;\n  }\n\n  .resources-menu .dropdown-content {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: -17px;\n    background-color: white;\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);\n    width: 150px;\n  }\n\n  .register-menu:hover .dropdown-content {\n    display: block;\n  }\n  .resources-menu:hover .dropdown-content {\n    display: block;\n  }\n\n  .register-menu.open .dropdown-content {\n    display: none;\n  }\n  .resources-menu.open .dropdown-content {\n    display: none;\n  }\n\n  .spacer {\n    height: 150px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
